module.exports = __webpack_public_path__ + "static/FairfestWhiteLogo-cd2924177aa86218d54cb82863f012d9.png";